var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBulb(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 108,
    viewBox: "0 0 86 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3539_1270)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 39.144,
    cy: 102.568,
    rx: 38.8691,
    ry: 4.05862,
    fill: "#B0CDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9092 31.2998C24.8777 17.5344 40.8753 11.2141 54.6406 17.1826C68.406 23.1512 74.7263 39.1487 68.7578 52.9141C66.6936 57.6745 63.4296 61.5449 59.4736 64.3242C53.2378 69.1913 47.602 73.3036 43.9814 75.8926L18.3418 64.7754C18.077 60.4938 17.6165 53.7196 16.9199 45.8301C16.2549 41.0563 16.8516 36.0454 18.9092 31.2998Z",
    fill: "#FDCA47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.6936 24.3779C53.1084 23.5564 52.7807 22.5472 51.928 22.2012C48.664 20.8767 45.1016 20.4208 41.5916 20.8927C38.0816 21.3647 34.7661 22.7453 31.9678 24.8849C31.2368 25.4439 31.1873 26.5037 31.8043 27.1865C32.4214 27.8692 33.4708 27.915 34.2107 27.3679C36.5027 25.6732 39.1929 24.5778 42.0357 24.1956C44.8784 23.8134 47.7623 24.1593 50.4206 25.1884C51.2788 25.5207 52.2788 25.1994 52.6936 24.3779Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.498 25.3585C84.2999 25.0416 85.2075 25.4354 85.5243 26.2374C85.8409 27.0392 85.4472 27.946 84.6454 28.2628L78.8378 30.5577C78.036 30.8745 77.1284 30.4815 76.8114 29.6798C76.4946 28.878 76.8877 27.9704 77.6894 27.6534L83.498 25.3585ZM58.9364 2.97859C59.2795 2.1876 60.2001 1.82407 60.9911 2.16706C61.7821 2.51015 62.1456 3.4307 61.8026 4.22175L59.3183 9.95124C58.9752 10.7424 58.0547 11.1058 57.2636 10.7628C56.4728 10.4197 56.1094 9.49998 56.4521 8.70906L58.9364 2.97859ZM27.5722 1.10945C28.374 0.792835 29.2807 1.18658 29.5976 1.98835L31.8925 7.79695C32.2091 8.59875 31.8163 9.50543 31.0146 9.82234C30.2127 10.1392 29.3051 9.7462 28.9882 8.94441L26.6933 3.13581C26.3765 2.33389 26.7703 1.42628 27.5722 1.10945Z",
    fill: "#FDCA47"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.8215,
    y: 41.4727,
    width: 3.12258,
    height: 29.1246,
    transform: "rotate(23.4411 37.8215 41.4727)",
    fill: "#4C7C9D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45.2705,
    y: 44.7012,
    width: 3.12258,
    height: 29.1254,
    transform: "rotate(23.4411 45.2705 44.7012)",
    fill: "#4C7C9D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.6978 79.2314C41.0474 80.0919 41.065 81.0864 40.6665 82.0059C40.0204 83.4961 38.4839 84.3233 36.9497 84.1377C38.134 85.1306 38.5801 86.8193 37.9341 88.3096C37.1467 90.1254 35.0361 90.959 33.2202 90.1719L31.6519 89.4912C29.4164 92.26 25.5327 93.3214 22.1089 91.8369C18.6853 90.3522 16.8042 86.7917 17.2974 83.2676L15.1587 82.3408C13.3429 81.5533 12.5092 79.4429 13.2964 77.627C13.9424 76.1373 15.4785 75.3091 17.0122 75.4941C15.8288 74.501 15.3828 72.8131 16.0288 71.3232C16.4274 70.4043 17.1651 69.7373 18.0317 69.4043L40.6978 79.2314Z",
    fill: "#4C7C9D"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49.1193,
    cy: 46.0306,
    r: 4.05936,
    transform: "rotate(23.4411 49.1193 46.0306)",
    fill: "#4C7C9D"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.0866,
    cy: 40.8118,
    r: 4.05936,
    transform: "rotate(23.4411 37.0866 40.8118)",
    fill: "#4C7C9D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0633 41.7498C39.0633 41.7498 41.9091 41.8841 43.4754 42.5633C45.0417 43.2424 47.0849 45.2279 47.0849 45.2279L45.7472 48.3132C45.7472 48.3132 43.8733 46.0346 42.2715 45.34C40.6696 44.6454 37.7255 44.835 37.7255 44.835L39.0633 41.7498Z",
    fill: "#4C7C9D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3539_1270"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 86,
    height: 108,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulb);
export default __webpack_public_path__ + "static/media/bulb.1ee1b7e883b476436f074d166e0a4676.svg";
export { ForwardRef as ReactComponent };